



















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getImgUrl } from "@/helper/ImgUrlHelper.ts";
import { siteConfig } from "@/SiteConfig.ts";

import AppContainerComponent from "@/components/AppContainerComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";

@Component({
  components: {
    AppContainerComponent,
    FooterComponent
  }
})
export default class HomeBannerComponent extends Vue {
  private pageTitle = `${siteConfig.title}`;

  private imgLink = siteConfig.imgLink;
  private imgAlt = siteConfig.title;

  private getImgUrl = getImgUrl;
}
